(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name authentication.controller:ChangePasswordCtrl
     *
     * @description
     *
     */
    angular
        .module('authentication')
        .controller('ChangePasswordCtrl', ChangePasswordCtrl);

    function ChangePasswordCtrl($location, AuthService, MessageService) {
        var vm = this;
            vm.model = {
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
                isChangePwError : false,
                changePasswordErrorMsg : null
            };

            vm.lengthValidation = false;
            vm.letterValidation = false;
            vm.capitalValidation = false;
            vm.numberValidation = false;
            vm.specialCharaterValidation = false;
            vm.isShowValidateMsg = false;

        vm.validatePassword = function() {
          // set password variable
            var password = vm.model.newPassword;

          if(password && password.length < 13 && password.length > 7 ) {
            vm.lengthValidation = true;
          } else {
            vm.lengthValidation = false;
          }

          //validate letter
          if(password && password.match(/[a-z]/) ) {
            vm.letterValidation = true;
          } else {
            vm.letterValidation = false;
          }

          //validate capital letter
          if(password && password.match(/[A-Z]/) ) {
            vm.capitalValidation = true;
          } else {
            vm.capitalValidation = false;
          }

          //validate number
          if(password && password.match(/\d/) ) {
            vm.numberValidation = true;
          } else {
            vm.numberValidation = false;
          }

          //validate special character
          if(password && password.match(/[!@#$%^&*(),.?":{}|<>]/) ) {
            vm.specialCharaterValidation = true;
          } else {
            vm.specialCharaterValidation = false;
          }
        };

        vm.showValidateMsg = function(){
          vm.isShowValidateMsg = true;
        }

        vm.hideValidateMsg = function(){
          vm.isShowValidateMsg = false;
        }


        vm.onChangePasswordClick = function () {

        	if(!checkPasswordValidity()){
        		 vm.model.isChangePwError = true;
                 vm.model.changePasswordErrorMsg = "Password should be minimum 8 and maximum 12 characters," +
                   "at least one uppercase letter,one lowercase letter, one number and one special character";
                 return;
        	}

          if(!confirmNewPassword()){
            vm.model.isChangePwError = true;
            vm.model.changePasswordErrorMsg = "New Password and Confirm Password does not match.";
            return;
          }

            AuthService.doChangePassword(vm.model.oldPassword, vm.model.newPassword,
                function (data) {

                  if(data.warnings.length>0){
                    angular.forEach(data.warnings,function(warning){
                      MessageService.warning(warning);
                    });

                  }

                  $location.path('/login');
                },
                function (error) {
                    vm.model.isChangePwError = true;
                    vm.model.changePasswordErrorMsg = error != null && error.msg.length > 0
                    	&& error.msg[0] != null ? error.msg[0] : "Change Password Fail.";
                    console.log(msg);
                }
            )
        };

        function checkPasswordValidity(){
        	// var passwordRegx = "^(?=.*[a-zA-Z].*[a-zA-Z].*[a-zA-Z].*)(?=.*\\d.*\\d.*\\d.*)[a-zA-Z0-9]{8,12}$";
          var passwordRegx = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,12}$";
        	var pattern = new RegExp(passwordRegx);
        	var result = pattern.test(vm.model.newPassword);
        	return result;
        };

        function confirmNewPassword(){
          return vm.model.newPassword == vm.model.confirmNewPassword;
        };
    }
}());
